import { render, staticRenderFns } from "./promos.vue?vue&type=template&id=717e93fe&"
import script from "./promos.vue?vue&type=script&lang=js&"
export * from "./promos.vue?vue&type=script&lang=js&"
import style0 from "./promos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports